module.exports = __webpack_public_path__ + "31f678806de8cc89fd231dfaf2402d78.pdf";